import { gsap } from '/shared.js';
import { THREE } from '/shared.js';

const bannerElem = document.getElementById('three-js-banner');
const sceneWidth = bannerElem.clientWidth;
const sceneHeight = bannerElem.clientHeight;

const mainScene = new THREE.Scene();
const mainCamera = new THREE.PerspectiveCamera(10, sceneWidth / sceneHeight, 0.1, 1000);
mainScene.background = new THREE.Color('#54214D');
mainCamera.position.set(0, 0, 200);
const mainRenderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas: bannerElem

});
mainRenderer.setSize(sceneWidth, sceneHeight);

function onResize() {

    const sizes = {};
    sizes.width = document.getElementById('three-js-banner-container').clientWidth
    sizes.height = document.getElementById('three-js-banner-container').clientHeight



    // Update camera
    mainCamera.aspect = sizes.width / sizes.height
    mainCamera.updateProjectionMatrix()

    // Update renderer

    mainRenderer.setSize(sizes.width, sizes.height)
    mainRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
}

window.addEventListener('resize', onResize);










const hemisphereGeom = new THREE.SphereGeometry(7.4, 32, 16, 0, Math.PI);
const hemisphereMat = new THREE.MeshStandardMaterial({ color: 0xF7F5F0, side: THREE.DoubleSide });
const hemisphereMesh = new THREE.Mesh(hemisphereGeom, hemisphereMat);
hemisphereMesh.position.x = 0;
// hemisphereMesh.rotation.x = Math.PI;
//mainScene.add(hemisphereMesh);

const baseCircleGeom = new THREE.CircleGeometry(7.4, 32);
const baseCircleMat = new THREE.MeshStandardMaterial({ color: 0xF7F5F0, side: THREE.DoubleSide });
const baseCircleMesh = new THREE.Mesh(baseCircleGeom, baseCircleMat);

// Match position and rotation
baseCircleMesh.position.copy(hemisphereMesh.position);
//baseCircleMesh.rotation.x = Math.PI; // Same as hemisphere

// mainScene.add(baseCircleMesh);

const hemisphereGroup = new THREE.Group();
hemisphereGroup.add(hemisphereMesh, baseCircleMesh);
hemisphereGroup.position.x = -35;
hemisphereGroup.rotation.x = Math.PI;


// Add the group to the scene
mainScene.add(hemisphereGroup);




const diamondPyramidGeom = new THREE.CylinderGeometry(0, 7.4, 5, 4);
const diamondPyramidMat = new THREE.MeshStandardMaterial({ color: 0xA0EDE2 });
const diamondPyramidMesh = new THREE.Mesh(diamondPyramidGeom, diamondPyramidMat);
diamondPyramidMesh.scale.x = 0.6;
diamondPyramidMesh.position.x = -19;
diamondPyramidMesh.rotation.x = 1.5 * Math.PI;
mainScene.add(diamondPyramidMesh);

const squarePyramidGeom = new THREE.ConeGeometry(7.4, 7.4, 4);
const squarePyramidMat = new THREE.MeshStandardMaterial({ color: 0xD0F1FB });
const squarePyramidMesh = new THREE.Mesh(squarePyramidGeom, squarePyramidMat);
squarePyramidMesh.position.x = -2.5;
squarePyramidMesh.rotation.x = 1.5 * Math.PI;
mainScene.add(squarePyramidMesh);


const coneGeom = new THREE.ConeGeometry(7.4, 10, 32);
const coneMat = new THREE.MeshStandardMaterial({ color: 0xD8DEFD });
const coneMesh = new THREE.Mesh(coneGeom, coneMat);
coneMesh.position.x = 16.5;
coneMesh.rotation.x = 1.5 * Math.PI;
mainScene.add(coneMesh);



// Create a short pyramid with a triangle base
const trianglePyramidGeometry = new THREE.ConeGeometry(
    8.4,    // base radius
    7.4,      // short height
    3       // 3 sides (triangle base)
);
const trianglePyramidMaterial = new THREE.MeshStandardMaterial({ color: 0x8F4F86 });
const trianglePyramid = new THREE.Mesh(trianglePyramidGeometry, trianglePyramidMaterial);

trianglePyramid.position.x = 35;
trianglePyramid.position.y = -2;
trianglePyramid.rotation.x = 1.5* Math.PI;

mainScene.add(trianglePyramid);


const ambient = new THREE.AmbientLight(0xffffff, .5);
mainScene.add(ambient);

const topDirLight = new THREE.DirectionalLight(0xffffff, 1);
topDirLight.position.set(0, 0, 5);
mainScene.add(topDirLight);

const dirLight = new THREE.DirectionalLight(0xffffff, 2);
dirLight.position.set(0, 0, 5);
dirLight.target.position.set(0, 0, -5);
mainScene.add(dirLight);
mainScene.add(dirLight.target);


const duration =7;
const tl = gsap.timeline({repeat:-1});
tl.to(hemisphereGroup.rotation, { y: hemisphereGroup.rotation.y + Math.PI * 2, duration:duration, ease: "power1.inOut" });
tl.to(diamondPyramidMesh.rotation, { z: diamondPyramidMesh.rotation.z + Math.PI * 2, duration: duration, ease: "power1.inOut"},`-=${duration/1.16}`);
tl.to(squarePyramidMesh.rotation, { z: squarePyramidMesh.rotation.z + Math.PI * 2, duration: duration, ease: "power1.inOut"},`-=${duration/1.16}`);
tl.to(coneMesh.rotation, { z: coneMesh.rotation.z + Math.PI * 2, duration: duration, ease: "power1.inOut"},`-=${duration/1.16}`);
tl.to(trianglePyramid.rotation, { z: trianglePyramid.rotation.z + Math.PI * 2, duration: duration, ease: "power1.inOut"},`-=${duration/1.16}`);
function runAnimation() {
    requestAnimationFrame(runAnimation);
    //  coneMesh.rotation.y += 0.01;
    mainRenderer.render(mainScene, mainCamera);
}
runAnimation();

//
//
//
//
// const mainGui = new GUI.GUI();
// const coneGuiFolder = mainGui.addFolder('Cone Transform');
// coneGuiFolder.add(hemisphereMesh.position, 'x', -sceneWidth / 2, sceneWidth / 2).name('Position X');
// coneGuiFolder.add(hemisphereMesh.position, 'y', -sceneHeight / 2, sceneHeight / 2).name('Position Y');
// coneGuiFolder.add(hemisphereMesh.position, 'z', -500, 500).name('Position Z');
// coneGuiFolder.add(hemisphereMesh.rotation, 'x', 0, Math.PI * 2).name('Rotation X');
// coneGuiFolder.add(hemisphereMesh.rotation, 'y', 0, Math.PI * 2).name('Rotation Y');
// coneGuiFolder.add(hemisphereMesh.rotation, 'z', 0, Math.PI * 2).name('Rotation Z');
// coneGuiFolder.add(hemisphereMesh.scale, 'x', 0.1, 3).name('Scale X');
// coneGuiFolder.add(hemisphereMesh.scale, 'y', 0.1, 3).name('Scale Y');
// coneGuiFolder.add(hemisphereMesh.scale, 'z', 0.1, 3).name('Scale Z');
// coneGuiFolder.open();

